<template lang="pug">

tr

    //- Name
    td: router-link(
        v-bind:to='{ name: "campaigns/update", params: { id: campaignModel.id } }'
        v-tooltip='"Kampagne bearbeiten"'
    ) {{ campaignModel.name }}

    //- Unternehmen
    td(v-if='$auth.isZmuekish')
        router-link(v-bind:to='{ name: "companies/update", params: { id: company.id }}') {{ company.name }}

    //- Start
    td {{ start }}

    //- Ende
    td {{ end }}

    //- Budget
    td {{ budget }}

</template>

<script>
    import * as fecha from 'fecha'
    import * as R from 'ramda'
    import { to_currency } from '@/utils/currency'

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            budget() {
                const lowerLimit = this.campaignModel.lowerLimit
                const budget     = this.campaignModel.budget

                if (R.and(R.isNil(lowerLimit), R.isNil(budget))) {
                    return '-'
                } else if (R.isNil(lowerLimit)) {
                    return `Bis ${to_currency('€')(budget)}`
                } else if (R.isNil(budget)) {
                    return `Ab ${to_currency('€')(lowerLimit)}`
                } else {
                    return `${to_currency('€')(lowerLimit)} - ${to_currency('€')(budget)}`
                }
            },

            company() {
                return R.find(R.propEq('id', this.campaignModel.company), this.companyModels)
            },

            end() {
                return this.parseDate(this.campaignModel.end)
            },

            start() {
                return this.parseDate(this.campaignModel.start)
            }

        },

        methods: {

            parseDate: R.ifElse(
                // Pruefen ob String
                R.is(String),

                // Zu Datum parsen
                date => fecha.format(new Date(date), 'DD.MM.YYYY'),

                // Default-String
                R.always('-')
            ),

        },

        props: {

            campaignModel: {
                type: Object,
                required: true
            },

            companyModels: {
                type: Array,
                required: true
            }

        }

    }

</script>
